/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Uploadable branding assets. The value is the URL path segment; each maps
 * to the ``Branding`` column the public URL is persisted to.
 */
export type BrandingAssetType =
  (typeof BrandingAssetType)[keyof typeof BrandingAssetType];

export const BrandingAssetType = {
  logo: "logo",
  "icon-192": "icon-192",
  "icon-512": "icon-512",
  maskable: "maskable",
  "apple-touch-icon": "apple-touch-icon",
  splash: "splash",
  favicon: "favicon",
  card: "card",
  "spend-card": "spend-card",
} as const;
